import { Injectable } from "@angular/core";
import { CommonApiService } from "./common-api.service";
import { APIURL } from "../global/constant";

@Injectable({
  providedIn: "root",
})
export class StoryboardService {
  constructor(private commonApiService: CommonApiService) { }

  fetchStoryboardDetails(
    storyboardId: number | string,
    options?: { campaign_video_aspect_ratio_id?: number | string },
  ) {
    const params =
      options?.campaign_video_aspect_ratio_id != null
        ? this.commonApiService.getParamsFromObj({
            campaign_video_aspect_ratio_id: options.campaign_video_aspect_ratio_id,
          })
        : undefined;
    return this.commonApiService.get(APIURL.storyboardDetails + storyboardId, params);
  }

  onGenerateStoryBoardShotImage(payload: any) {
    return this.commonApiService.post(APIURL.storyboardImageGenerate, payload);
  }

  onGenerateStoryBoardShotImageV2(payload: any) {
    return this.commonApiService.post(
      APIURL.storyboardImageGenerateV2,
      payload,
    );
  }

  /** POST `/autonomous-generation/storyboard` — legacy batch frame generation. */
  autonomousGenerationStoryboard(payload: {
    video_id: number | string;
    user_instructions?: string;
    model_id?: string;
    scope?: string;
    req_type?: string;
    campaign_video_aspect_ratio_id?: number | string;
  }) {
    return this.commonApiService.post(
      APIURL.autonomousGenerationStoryboard,
      payload,
    );
  }

  /** POST `/autonomous-generation/storyboard-v2` — batch frame generation with shot checklist. */
  autonomousGenerationStoryboardV2(payload: {
    video_id: number | string;
    storyboard_id: number | string;
    model_id?: number | string;
    variations?: number;
    frame_type?: string;
    user_instructions?: string;
    campaign_video_aspect_ratio_id?: number | string;
    notify_trigger?: string;
    scope?: "all" | "no-frame";
    shot_ids?: number[];
  }) {
    return this.commonApiService.post(
      APIURL.autonomousGenerationStoryboardV2,
      payload,
    );
  }

  uploadStoryImage(formData: FormData) {
    return this.commonApiService.post(APIURL.uploadStoryImage, formData);
  }

  /** Copy a library asset image into this shot as a new storyboard variation. */
  importStoryImage(payload: {
    shot_id: number | string;
    storyboard_id: number | string;
    campaign_video_aspect_ratio_id?: number | string | null;
    image_url: string;
    source_variation_id?: number | null;
    asset_id?: string | number | null;
  }) {
    return this.commonApiService.post(APIURL.importStoryImage, payload);
  }

  uploadvideorefimage(formData: FormData) {
    return this.commonApiService.post(APIURL.uploadvideorefimage, formData);
  }

  onShotImageApproval(payload: any) {
    return this.commonApiService.post(APIURL.shotImageApprove, payload);
  }

  updateStoryboardImageViewStatus(payload: {
    shot_id: number | string;
    variation_id: number | string;
  }) {
    return this.commonApiService.post(
      APIURL.storyboardImageUpdateViewStatus,
      payload,
    );
  }

  getStoryboardImageLlmData(payload: {
    shot_id: number | string;
    variation_id: number | string;
  }) {
    return this.commonApiService.post(APIURL.storyboardImageLlmData, payload);
  }

  deleteShotImageVariation(
    shotId: number | string,
    imageId: number | string,
    options?: { campaign_video_aspect_ratio_id?: number | string },
  ) {
    const params =
      options?.campaign_video_aspect_ratio_id != null
        ? this.commonApiService.getParamsFromObj({
            campaign_video_aspect_ratio_id: options.campaign_video_aspect_ratio_id,
          })
        : undefined;
    return this.commonApiService.delete(
      `${APIURL.shotImageVariationDelete}${shotId}/${imageId}`,
      params,
    );
  }

  // onShotImageReadyForReview(payload: {
  //   image_id: number | string;
  //   shot_id: number | string;
  //   status: string;
  // }) {
  //   return this.commonApiService.post(APIURL.shotImageReadyForReview, payload);
  // }

  getShotDetails(shotId: number | string, payload: any) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.shotDetails + shotId, params);
  }

  onVideoVisualDnaCreate(payload: any) {
    return this.commonApiService.post(APIURL.videoVisualDnaCreate, payload);
  }

  getVideoLevelDnaOptions(videoId: number | string) {
    const params = this.commonApiService.getParamsFromObj({ video_id: videoId });
    return this.commonApiService.get(APIURL.videoLevelDnaOptions, params);
  }

  updateCampaignVideoDna(payload: {
    video_id: number;
    storyboard_id: number;
    visual_style_id: number;
    texture_id: number;
    color_palette_id: number;
    grade_treatment_id: number;
    composition_approach_id: number;
    justification?: Record<string, unknown>;
  }) {
    return this.commonApiService.post(APIURL.campaignVideoDnaUpdate, payload);
  }

  uploadVisualDnaReferences(formData: FormData) {
    return this.commonApiService.post(
      APIURL.campaignVideoVisualDnaReferencesUpload,
      formData,
    );
  }

  deleteVisualDnaReference(referenceId: number | string) {
    return this.commonApiService.delete(
      APIURL.campaignVideoVisualDnaReferenceDelete + referenceId,
    );
  }

  analyzeVisualDnaReferences(payload: {
    video_id: number | string;
    storyboard_id: number | string;
    user_instructions?: string;
  }) {
    return this.commonApiService.post(
      APIURL.campaignVideoAnalyzeReferences,
      payload,
    );
  }
}
